// import React, { useEffect } from "react";

// import { Add, FormClose, StatusGood, StatusCritical } from "grommet-icons";

// import { Box, Button, Layer, Text } from "grommet";
// import { observer } from "mobx-react";
// import { useStore } from "../../../../../Hooks/useStore";

// type NotificationToastProps = {
//   text: string;
//   showToast: boolean;
//   onCancelOrDone: () => void;
//   noExpiring?: boolean;
// };

// export const NotificationToast = observer(() => {

//   const { rootStore } = useStore();

//   useEffect(() => {
//     if (rootStore.notificationToastStore.getShow) onOpen();
//   }, [rootStore.notificationToastStore.getShow]);

//   const onOpen = () => {
//     setTimeout(() => {
//       rootStore.notificationToastStore.handleShow(false);
//     }, 3000);
//   };

//   return (
//     // Uncomment <Grommet> lines when using outside of storybook
//     // <Grommet theme={...}>
//     <>
//       {rootStore.notificationToastStore.getShow && (
//         <Layer
//           position="bottom"
//           modal={false}
//           margin={{ vertical: "medium", horizontal: "small" }}
//           onEsc={() => rootStore.notificationToastStore.handleShow(false)}
//           responsive={false}
//           plain
//         >
//           {
//             rootStore.notificationToastStore.getText !== "There was an error while attempting to send the email."
//             ?
//           <Box
//             align="center"
//             direction="row"
//             gap="small"
//             justify="between"
//             round="medium"
//             elevation="medium"
//             pad={{ vertical: "xsmall", horizontal: "small" }}
//             background="status-ok"
//           >
//             <Box align="center" direction="row" gap="xsmall">
//               <StatusGood />
//               <Text>{rootStore.notificationToastStore.getText}</Text>
//             </Box>
//           </Box>
//           :
//           <Box
//             align="center"
//             direction="row"
//             gap="small"
//             justify="between"
//             round="medium"
//             elevation="medium"
//             pad={{ vertical: "xsmall", horizontal: "small" }}
//             background="#FD7272"
//           >
//             <Box align="center" direction="row" gap="xsmall">
//               <StatusCritical />
//               <Text>{rootStore.notificationToastStore.getText}</Text>
//             </Box>
//           </Box>
//           }
//         </Layer>
//       )}
//     </>
//     // </Grommet>
//   );
// });

import React, { useEffect } from "react";

import { Add, FormClose, StatusGood, StatusCritical } from "grommet-icons";

import { Box, Button, Layer, Text } from "grommet";
import { observer } from "mobx-react";
import { useStore } from "../../../../../Hooks/useStore";
import successFullVerfy from "../../../../../assets/Verify (1).svg"
import error from '../../../../../assets/report (1).svg'

type NotificationToastProps = {
  text: string;
  showToast: boolean;
  onCancelOrDone: () => void;
  noExpiring?: boolean;
};

export const NotificationToast = observer(() => {
  const { rootStore } = useStore();

  useEffect(() => {
    if (rootStore.notificationToastStore.getShow) onOpen();
  }, [rootStore.notificationToastStore.getShow]);

  const onOpen = () => {
    setTimeout(() => {
      rootStore.notificationToastStore.handleShow(false);
      rootStore.notificationToastStore.handleError(false);
    }, 3000);
  };

  return (

    <>
      {rootStore.notificationToastStore.getShow && (
        <Layer
          position="bottom"
          modal={false}
          margin={{ vertical: "medium", horizontal: "small" }}
          onEsc={() => rootStore.notificationToastStore.handleShow(false)}
          responsive={false}
          plain
        >
          {
           !rootStore.notificationToastStore.getError
            ?
          <Box
            align="center"
            direction="row"
            gap="small"
            justify="between"
            round="medium"
            elevation="medium"
            pad={{ vertical: "xsmall", horizontal: "small" }}
            background="status-ok"
          >
            <Box style={{
              display: "inline-flex",
              padding: "14px 20px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",
              borderRadius: "12px",
            }} align="center" direction="row" gap="xsmall">
          
              <Box style={{display: "flex",
              flexDirection:"row",
              alignItems: "center",
              gap: "10px"}}>   
              <img style={{
                width: "32px",
              height: "32px"
              }}src={successFullVerfy}/>
              <Text style={{
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "22px",
              }}>{rootStore.notificationToastStore.getText}</Text>
              </Box>
            </Box>
          </Box>
          :
          <Box
            align="center"
            direction="row"
            gap="small"
            justify="between"
            round="medium"
            elevation="medium"
            pad={{ vertical: "xsmall", horizontal: "small" }}
            background="#FD7272"
          >
            <Box style={{    display: 'inline-flex',
    padding: '14px 20px',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '12px',
    background: '#FD7272',
            }}align="center" direction="row" gap="xsmall">
  <img style={{
                width: "32px",
              height: "32px"
              }}src={error}/>
          
              <Text style={{color: '#FFF',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '22px'}}>{rootStore.notificationToastStore.getText}</Text>

            </Box>
            </Box>
          }
        </Layer>
      )}
    </>
  );
});

